module.exports = __webpack_public_path__ + "static/media/noDataList.ca7b26b2.png";